/**
* @ngdoc directive
* @name Replace
*
* @description
  Used to replace ng-include
  on inventory, waste reports pages
  to fix table markup issue
  and let reuse templates
*
*/

(function() {

  app.directive('replace', replace);

  function replace() {
    var directive = {
      replace: true,
      link: function($scope, $element) {
        var content = $element.contents();
        $element.replaceWith(content);
      }
    };

    return directive;
  }

})();



// WEBPACK FOOTER //
// ./~/ng-annotate-loader/loader.js!./project/components/replaceDirective.js